import './LoadingPage.css';

// import { logo4DBALTDYN } from '../../theme/images';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';

export default () => (
    <div id="loading-page-custom">
        {/* <img className="loading-logo" alt={"4DBALTDYN logo"} src={logo4DBALTDYN} /> */}
        <p>4DBALTDYN App</p>
        <Spinner white height={30} />
    </div>
);